module.exports = __webpack_public_path__ + "media/assets/preview-3eff92a91c1bc54810aaa9883dbee096.svg";